<template>
    <v-container>
    <v-card class="pa-4">
      <v-card-title class="text-h5">Instructivo para instalar la aplicación</v-card-title>
      <v-card-text>
        <ol>
          <li>
            <strong>Habilitar la instalación de aplicaciones de fuentes desconocidas:</strong>
            <ul>
              <li>Abre la <em>Configuración</em> de tu dispositivo Android.</li>
              <li>Dirígete a <em>Seguridad</em> o <em>Privacidad</em> (según tu dispositivo).</li>
              <li>Activa la opción <strong>Permitir instalaciones de fuentes desconocidas</strong>.</li>
            </ul>
          </li>
          <li>
            <strong>Descargar el archivo APK:</strong>
            <ul>
              <li>Abre el navegador en tu dispositivo Android.</li>
              <li>Visita el enlace proporcionado por el administrador del sistema.</li>
              <li>Haz clic en el enlace para iniciar la descarga del archivo APK.</li>
            </ul>
          </li>
          <li>
            <strong>Instalar el APK:</strong>
            <ul>
              <li>Una vez descargado, abre el archivo APK desde la notificación o en la carpeta <em>Descargas</em>.</li>
              <li>Si es necesario, otorga los permisos solicitados para continuar.</li>
              <li>Presiona <strong>Instalar</strong> y espera a que termine el proceso.</li>
            </ul>
          </li>
          <li>
            <strong>Finalizar:</strong>
            <ul>
              <li>Una vez instalada, abre la aplicación desde el menú principal.</li>
              <li>¡Listo! La aplicación está instalada y lista para usar.</li>
            </ul>
          </li>
        </ol>
        <v-alert type="info" class="mt-4">
          <strong>Nota:</strong> Asegúrate de descargar el archivo APK desde una fuente confiable para evitar riesgos de seguridad.
        </v-alert>
      </v-card-text>
    </v-card>
    <div class="download-app">
        <v-row justify="center" class="mt-4">
        <v-btn color="primary" @click="downloadFile">
            Descargar Aplicación
        </v-btn>
    </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
    name: 'DownloadApp',
    methods: {
        downloadFile() {
            const link = document.createElement('a');
            link.href = 'https://finishtime.com.ar/downloads/app/finishtime-acreditaciones.apk'; // Replace with the actual path to your file
            link.download = 'finishtime-acreditaciones.apk'; // Replace with the actual file name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}
</script>

<style scoped>
.download-app {
    display: flex;
    justify-content: center;
    align-items: center; 
   
}

button {
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
}
</style>